import { ScenarioAssetMappingBase } from './base/scenario-asset-mapping-base';

export class ScenarioAssetMapping extends ScenarioAssetMappingBase { }